import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { useTranslation } from '@infra/i18n';

const LOADER_DELAY_S = 0.2;

export function LoadingScreen() {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      // Hold back so a fast route or namespace swap never flashes the loader.
      transition={{ delay: LOADER_DELAY_S, duration: 0.2 }}
      className="fixed inset-0 flex items-center justify-center bg-background"
    >
      <div className="flex flex-col items-center gap-4">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
        >
          <Loader2 className="w-8 h-8 text-primary" />
        </motion.div>
        <p className="text-sm text-muted-foreground">{t('common:messages.loading')}</p>
      </div>
    </motion.div>
  );
}
